import { IconB1, IconB2, IconB3, IconB4, IconB5, IconB6, IconA10, IconA11, IconA12 } from '../SolarPower/Svg';
import { textLang } from './textLang';
export const getIconList = (locale: string, tab: 'a' | 'b' | 'c') => {
    return [
        {
            name: textLang[locale].icon1,
            icon: IconB1,
        },
        {
            name: textLang[locale].icon2,
            icon: IconB2,
        },
        {
            name: textLang[locale].icon3,
            icon: IconB3,
        },
        {
            name: textLang[locale].icon4,
            icon: IconB4,
        },
        {
            name: textLang[locale].icon5,
            icon: IconB5,
        },
        {
            name: textLang[locale].icon6,
            icon: IconB6,
        },
        {
            name: textLang[locale].icon7,
            icon: IconA10,
        },
        {
            name: textLang[locale].icon8,
            icon: IconA11,
        },
        {
            name: textLang[locale].icon9,
            icon: IconA12,
        },
    ];
};
